import PropTypes from 'prop-types';
import {
    defineMessages,
    injectIntl, 
    // intlShape
} from 'react-intl';
import {connect} from 'react-redux';
import React from 'react';
// import VM from 'scratch-vm';
import './drawer.css';
import bindAll from 'lodash.bindall';
import noCamera from './assets/noCamera.png';
import WifiConnectModal from './components/wifi-connect-modal';
import WifiConnectLoadModal from './components/wifi-connect-loading.jsx';
import WifiConnectErrorModal from './components/wifi-connect-error.jsx';
import WifiConnectSuccessModal from './components/wifi-connect-success.jsx';
import VideoStream from './components/VideoStream.jsx';
import Webcam from 'react-webcam';
import {getMobileOS} from '../lib/supported-browser.js';
import { setConnectModal } from '../store/modals'
import { Spin, message } from 'antd';
import { Icon, Switch, extendTheme, ChakraProvider } from "@chakra-ui/react";
import { Select } from "@chakra-ui/select";


// const {Option} = Select;
const messages = defineMessages({
    camFrontcamera: {
        defaultMessage: 'Front camera',
        description: 'Front camera',
        id: 'gui.homePage.camFrontcamera'
    },
    camWIFIImageTransmission: {
        defaultMessage: 'WIFI image transmission',
        description: 'WIFI image transmission',
        id: 'gui.homePage.camWIFIImageTransmission'
    },
    camTransmissionOpen: {
        defaultMessage: 'Open',
        description: 'Open',
        id: 'gui.homePage.camTransmissionOpen'
    },
    camTransmissionClose: {
        defaultMessage: 'Close',
        description: 'Close',
        id: 'gui.homePage.camTransmissionClose'
    },
    camDeviceTitle: {
        defaultMessage: 'Please connect the device',
        description: 'Please connect the device',
        id: 'gui.homePage.camDeviceTitle'
    },
    ErrorVideoIp: {
        defaultMessage: 'IP address error',
        description: 'IP address error',
        id: 'gui.homePage.ErrorVideoIp'
    },
    cameraNot: {
        defaultMessage: 'The camera is not supported',
        description: 'The camera is not supported',
        id: 'gui.homePage.cameraNot'
    },
    connectAPeripheralFirst: {
        defaultMessage: 'Plese connect a peripheral first',
        description: 'Plese connect a peripheral first',
        id: 'gui.homePage.connectAPeripheralFirst'
    },
    camOpenWifiTransmission: {
        defaultMessage: 'Please open WIFI image transmission first',
        description: 'Please open WIFI image transmission first',
        id: 'gui.homePage.camOpenWifiTransmission'
    },
    camDeviceloadTitle: {
        defaultMessage: 'Connecting devices',
        description: 'Connecting devices',
        id: 'gui.homePage.camDeviceloadTitle'
    }
});


class CameraComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleChange', 'onSwitchChange', 'handleChildData']);
        this.state = {
            activeIndex: 0,
            switchState: false,
            showWifiConnect: false,
            showWifiConnectLoad: false,
            showWifiConnectError: false,
            showWifiConnectSuccess: false,
            switchOpenState: false,
            cams: 'Nous',
            showWebCam: false,
            url: '',
            loadingOpenStatus: false
        };
        this.componentReady = React.createRef();
        const timeoutErrorId = null;
        const timeoutSuccessId = null;
        this.webcamRef = React.createRef();
        this.videoRef = React.createRef();
        // 初始化
        // this.handleToRecord = debounce(this.handleToRecord, 100);
        this.videoConstraints = {
            width: 1280,
            height: 720,
            facingMode: 'environment'
        };
        // window.teachableMachine.init()
        //     .then(() => {
        //         this.setState({
        //             loading: false
        //         });
        //     });
    }

    componentDidMount () {
        this.componentReady.current = true;
        // console.log(this.state.showWifiConnectError, 999)
        // this.onUpdateStyle();
    }

    shouldComponentUpdate (nextProps, nextState) {
        console.log()
        // activeIndex, callback, controlRef, segments
        return nextState;
    }

    componentDidUpdate (preProps) {
        if (preProps.isConnected === true && this.props.isConnected === false && this.state.cams === 'Nous') {
            // console.log('preProps.isConnected', preProps.isConnected, '现在的链接状态：', this.props.isConnected);
            this.setState({
                activeIndex: 0,
                switchState: false,
                showWifiConnect: false,
                showWifiConnectLoad: false,
                showWifiConnectError: false,
                showWifiConnectSuccess: false,
                switchOpenState: false,
                // cams: 'Nous',
                showWebCam: false,
                url: '',
                loadingOpenStatus: false
            });
        }
        // this.onUpdateStyle();
    }

    componentWillUnmount () {
        // recycle the DOM nodes
        this.props.segments.forEach(segment => {
            segment.ref.current.remove();
        });
        this.componentReady = null;
        clearTimeout(this.timeoutErrorId);
        clearTimeout(this.timeoutSuccessId);
    }

    handleChange (e) {
        this.setState(
            {
                cams: event.target.value,
                switchOpenState: false,
                showWebCam: false,
                switchState: false
            },
            () => {
                // console.log(this.state, 8989)
            }
        );
        // window.teachableMachine?.cleanup();
        // this.forceUpdate()
    }

    onSwitchChange (event) {
        if (this.state.cams === 'Nous') {
            if (event.currentTarget.checked) {
                // console.log(!window.peripheral.isConnected(), 9999)
                // 没有连接小车
                if (!window.peripheral.isConnected()) {
                    this.props.setConnectModal(true)
                    return;
                }
            } else {
                this.setState({
                    switchOpenState: false,
                    showWebCam: false
                });
            }
            this.setState({
                showWifiConnect: event.currentTarget.checked,
                switchState: event.currentTarget.checked
            });
        } else {
            const shower = document.getElementById('show');
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
            if (navigator.getUserMedia) {
                this.setState({
                    switchState: event.currentTarget.checked
                });
                return;
            }
            message.error(this.props.intl.formatMessage(messages.cameraNot));
        }
    }

    handleChildData (data) {
        if (data === 'ok') {
            this.setState({
                showWifiConnect: false
            });
        }
        // 等待连接弹框
        if (data === 'loading') {
            this.setState({
                showWifiConnect: false,
                showWifiConnectLoad: true
            });
        }
        // 连接错误弹框
        if (data === 'error') {
            // 没有连接小车
            // if (!this.props.vm.getPeripheralIsConnected('Nous')) {
            //     this.setState({
            //         showWifiConnect: false,
            //         showWifiConnectLoad: false,
            //         switchState: false
            //     });
            //     message.error(this.props.intl.formatMessage(messages.connectAPeripheralFirst));
            //     return;
            // }
            this.setState({
                showWifiConnectError: true,
                showWifiConnectLoad: false,
                showWifiConnect: false
            });
        }
        // 成功时弹框
        if (data === 'success') {
            this.setState({
                showWifiConnectSuccess: true,
                showWifiConnectLoad: false,
                showWifiConnect: false,
                switchState: true
            });
        }
        if (this.state.showWifiConnectError) {
            this.timeoutErrorId = setTimeout(() => {
                this.setState({
                    showWifiConnectError: false,
                    switchState: false
                });
            }, 1500);
        }
        if (this.state.showWifiConnectSuccess) {
            this.timeoutSuccessId = setTimeout(() => {
                this.setState({showWifiConnectSuccess: false});
            }, 1000);
        }
    }

    onSwitchOpenChange (value) {
        // 图传为true时
        if (!value) {
            // 选择为本地摄像头
            if (this.state.cams === 'Webcam') {
                if (getMobileOS() === 'PC') {
                    this.hiddenVideo = document.createElement('video');
                    this.hiddenVideo.style.display = 'none';
                    document.body.appendChild(this.hiddenVideo);
                    // window.teachableMachine.initCam(this.hiddenVideo);
                    this.setState(
                        {
                            switchOpenState: true,
                            showWebCam: true,
                            showWifiConnectSuccess: true
                        },
                        () => {
                            if (this.state.showWifiConnectSuccess) {
                                this.timeoutSuccessId = setTimeout(() => {
                                    this.setState({showWifiConnectSuccess: false});
                                }, 1000);
                            }
                        }
                    );
                } else {
                    // 非pc端 暂不支持摄像头
                    message.error(this.props.intl.formatMessage(messages.cameraNot));
                }
            } else if (!this.state.switchState) {
                message.error(this.props.intl.formatMessage(messages.camOpenWifiTransmission));
                return;
            } else {
                this.setState({
                    loadingOpenStatus: true,
                    showWebCam: true,
                    switchOpenState: true
                });
                // 选择为Nous摄像头、首先获取Nous的ip地址
                window.peripheral.cameraStart().then(i => {
                    console.log(i, 'ip');
                    // 192.168.0.83
                    // 判读是否为ip地址
                    const pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
                    if (i && pattern.test(i)) {
                        this.setState({
                            url: i,
                            // showWebCam: true,
                            // switchOpenState: true,
                            loadingOpenStatus: false
                        });
                    } else {
                        message.error(this.props.intl.formatMessage(messages.ErrorVideoIp));
                        this.setState({
                            showWifiConnectLoad: false
                        })
                        return;
                    }
                });
                // this.setState({
                //     url: '192.168.0.83',
                //     showWebCam: true,
                //     switchOpenState: true
                // })
            }
        } else {
            this.setState({
                switchOpenState: false,
                showWebCam: false
            });
            this.hiddenVideo?.remove();
            // window.teachableMachine?.cleanup();
        }
    }

    handleUserMedia = () => {
        this.setState({loading: false});
    };

    render () {
        const {intl} = this.props;
        const {switchState, switchOpenState, showWebCam, cams, loadingOpenStatus} = this.state;
        return (
            <div>
                {/* 展示连接wifi的弹框 */}
                {this.state.showWifiConnect ? (
                    <WifiConnectModal
                        onCloseModal={() => {
                            this.setState({showWifiConnect: false, switchState: false});
                            this.forceUpdate();
                        }}
                        onChildData={this.handleChildData}
                    />
                ) : null}
                {/* 展示wifi loading */}
                {this.state.showWifiConnectLoad && <WifiConnectLoadModal />}
                {/* 展示wifi 连接失败 */}
                {this.state.showWifiConnectError && <WifiConnectErrorModal />}
                {/* 展示wifi 连接成功 */}
                {this.state.showWifiConnectSuccess && <WifiConnectSuccessModal />}
                <div
                    className="cameraContainer"
                    ref={this.props.controlRef}
                >
                    <div style={{textAlign: 'center', marginTop: '15px'}}>
                        <Select
                            value={this.state.cams}
                            onChange={this.handleChange}
                            className="cameraSelect"
                        >
                            <option key="Nous" value="Nous" style={{lineHeight: '20px', fontSize: '14px'}}>Nous AI Cam</option>
                            <option key="Webcam" value="Webcam" style={{lineHeight: '20px', fontSize: '14px'}}>{intl.formatMessage(messages.camFrontcamera)}</option>
                        </Select>
                        
                        {this.state.cams === 'Nous' && (
                            <div className="cameraWifi">
                                <div style={{float: 'left', margin: '0 0px 0px 10px'}}>
                                    <span style={{color: '#575E75'}}>{intl.formatMessage(messages.camWIFIImageTransmission)}：</span>
                                    <span style={{color: '#77a5f2'}}>
                                        {this.state.switchState ? intl.formatMessage(messages.camTransmissionOpen) : intl.formatMessage(messages.camTransmissionClose)}
                                    </span>
                                </div>
                                <Switch
                                    style={{float: 'right', margin: '5px 10px 0 0'}}
                                    isChecked={switchState}
                                    onChange={this.onSwitchChange}
                                />
                            </div>
                        )}
                        <div className="cameraWebcam">
                            <Switch
                                style={{float: 'right', margin: '5px 10px 0 0', zIndex: '99'}}
                                isChecked={switchOpenState}
                                onChange={() => {
                                    this.onSwitchOpenChange(switchOpenState);
                                }}
                            />
                            {/* 摄像头是否连接 */}
                            {!showWebCam ? (
                                <div className="noCamera">
                                    <img
                                        height="30"
                                        width="30"
                                        src={noCamera}
                                    />
                                    <div>{intl.formatMessage(messages.camDeviceTitle)}</div>
                                </div>
                            ) : // 首先展示loading状态
                                loadingOpenStatus ? (
                                    <div className="noCamera">
                                        <Icon
                                            type="loading"
                                            style={{fontSize: '20px'}}
                                        />
                                        <div>{intl.formatMessage(messages.camDeviceloadTitle)}</div>
                                    </div>
                                ) : // <Spin spinning={this.state.loading}>
                                //     {
                                // 摄像头为本地摄像头
                                    cams === 'Webcam' ? (
                                        getMobileOS() === 'PC' && (
                                            <Webcam
                                                ref={this.webcamRef}
                                                audio={false}
                                                // forceScreenshotSourceSize
                                                onUserMedia={this.handleUserMedia}
                                                width={'100%'}
                                                height={'145px'}
                                                mirrored={false}
                                                // width={'10vw'}
                                                // height={'10vw'}
                                                videoConstraints={this.videoConstraints}
                                                screenshotFormat="image/jpeg"
                                                style={{
                                                    textAlign: 'center',
                                                    minHeight: '144px',
                                                    maxWidth: '240px',
                                                    objectFit: 'cover',
                                                    borderRadius: '16px',
                                                    position: 'absolute',
                                                    // marginTop: '-27px'
                                                    // maxWidth: '200px',
                                                    // maxHeight: '200px'
                                                }}
                                            />
                                        )
                                    ) : (
                                    // <input
                                    //     type="file"
                                    //     accept="video/*"
                                    //     capture="camera"
                                    //     style={{
                                    //         width: '61%',
                                    //         margin: '36px'
                                    //     }}
                                    // />
                                    // <video autoPlay ref={this.videoRef} />
                                        <div>
                                            {/* <video
                                                    ref={this.videoRef}
                                                    id="video"
                                                    autoplay
                                                    style="width: 480px;height: 320px"
                                                ></video>
                                                <canvas
                                                    id="canvas"
                                                    width="480"
                                                    height="320"
                                                ></canvas> */}
                                            <VideoStream
                                                url={this.state.url}
                                                width="100%"
                                                height="100%"
                                                type="drawer"
                                            />
                                        </div>
                                    )
                            //     }
                            // </Spin>
                            }
                        </div>
                        <div className="cameraline" />
                        <div className="cameraOutput">
                            <div className="output">Output</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CameraComponent.defaultProps = {
    callback: () => {},
    controlRef: React.createRef(),
    segments: []
};
const mapStateToProps = state => ({
    // methodModalOpen: state.scratchGui.modals.connectionMethodModal,
    // vm: state.scratchGui.vm
    isConnected: state.connectStore.isConnected
});
const mapDispatchToProps = dispatch => ({
    setConnectModal: (state) => dispatch(setConnectModal(state))
});
CameraComponent.propTypes = {
    // vm: PropTypes.instanceOf(VM).isRequired,
    // intl: intlShape.isRequired,
    name: PropTypes.string,
    callback: PropTypes.func,
    defaultIndex: PropTypes.number,
    controlRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.instanceOf(Element)})]),
    onOpenConnctionBulletBox: PropTypes.func,
    isConnected: PropTypes.bool,
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CameraComponent));
// export default injectIntl(CameraComponent);
